"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const BrushTracker_1 = require("../../EventsTrackers/BrushTracker");
const MouseTracker_1 = require("../../EventsTrackers/MouseTracker");
const ChartContext_1 = require("../../context/ChartContext");
const ScaleContext_1 = require("../../context/ScaleContext");
const useActiveSpectrum_1 = require("../../hooks/useActiveSpectrum");
const useFormatNumberByNucleus_1 = require("../../hooks/useFormatNumberByNucleus");
const style = {
    cursor: 'crosshair',
    transformOrigin: 'bottom right',
    position: 'absolute',
    top: '-18px',
    left: '-30px',
    pointerEvents: 'none',
    overflow: 'visible',
    userSelect: 'none',
};
function XLabelPointer() {
    const { height, width, margin, data } = (0, ChartContext_1.useChartData)();
    const activeSpectrum = (0, useActiveSpectrum_1.useActiveSpectrum)();
    const { scaleX } = (0, ScaleContext_1.useScaleChecked)();
    const position = (0, MouseTracker_1.useMouseTracker)();
    const brushState = (0, BrushTracker_1.useBrushTracker)();
    const activeSpectrumData = (0, react_1.useMemo)(() => {
        const spectrumData = activeSpectrum
            ? data.find((d) => d.id === activeSpectrum.id)
            : null;
        return spectrumData;
    }, [activeSpectrum, data]);
    const format = (0, useFormatNumberByNucleus_1.useFormatNumberByNucleus)(activeSpectrumData?.info.nucleus);
    const getXValue = (0, react_1.useCallback)((xVal) => {
        if (activeSpectrumData) {
            const xInvert = scaleX().invert(xVal);
            return format(xInvert);
        }
    }, [activeSpectrumData, format, scaleX]);
    if (!activeSpectrum ||
        brushState.step === 'brushing' ||
        !position ||
        position.y < margin.top ||
        position.x < margin.left ||
        position.x > width - margin.right ||
        position.y > height - margin.bottom) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)("div", { style: {
            ...style,
            transform: `translate(${position.x}px, ${position.y}px)`,
        }, children: (0, jsx_runtime_1.jsx)("span", { children: getXValue(position.x) }) }, "xLabelPointer"));
}
exports.default = XLabelPointer;
